import React from "react";
import { Link } from "react-router-dom";

/**
 * Two-tone WriterSpark wordmark + logo image.
 * - "Writer" matches the background context (dark on light, white on dark)
 * - "Spark" is always violet, matching the logo glyph color
 * Usage: <Brand to="/" tone="light" size="lg" />
 *   tone: "light" (for white/light bg) | "dark" (for navy/dark bg)
 *   size: "md" (headers) | "lg" (auth pages, footer)
 */
export default function Brand({ to = "/", tone = "light", size = "md", testId = "brand-link" }) {
  const sizes = {
    md: { img: "w-10 h-10", text: "text-xl" },
    lg: { img: "w-12 h-12", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  const writerColor = tone === "dark" ? "text-white" : "text-slate-900";

  return (
    <Link to={to} data-testid={testId} className="flex items-center gap-2.5 group">
      <img
        src="/writespark-logo.png"
        alt="WriterSpark logo"
        className={`${s.img} rounded-2xl object-contain`}
      />
      <span
        className={`font-black tracking-tight leading-none ${s.text}`}
        style={{ fontFamily: "Outfit" }}
      >
        <span className={writerColor}>Writer</span>
        <span className="text-violet-600">Spark</span>
      </span>
    </Link>
  );
}
